import React from 'react';
import { FDStack } from '@facet-wealth/design';
import Proptypes from 'prop-types';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';

export const FDWizardSubtitle = ({ value }) => {
  if (Array.isArray(value)) {
    return (
      <FDStack direction={'column'} spacing={1}>
        {value
        // eslint-disable-next-line react/no-array-index-key -- we don't have anything better to use as a key here
          ? value.map((v, i) => <BodyTextMedium key={i} value={v} />)
          : null}
      </FDStack>
    );
  }

  return <BodyTextMedium value={value} />;
};

FDWizardSubtitle.propTypes = {
  value: Proptypes.array.isRequired,
};
